import styleVars from '!less-vars-loader?resolveVariables,camelCase!../../../../less/variables.less';

const state = {
    activeSection: null,

    styleVars,

    navigationVisible: false,
};

export default state;
